import { z } from 'zod';

// Refresh responses only return identity fields in the body — ws tokens are
// delivered via Set-Cookie and don't appear in the JSON. Keep this schema
// strictly aligned to what the backend returns on /token/refresh.
export const refreshResponseSchema = z.object({
  user_type: z.number(),
  access_expiration: z.coerce.string().datetime(),
  refresh_expiration: z.coerce.string().datetime(),
});
